import { render, staticRenderFns } from "./GasOrderList.vue?vue&type=template&id=566d52bd&scoped=true"
import script from "./GasOrderList.vue?vue&type=script&lang=js"
export * from "./GasOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d52bd",
  null
  
)

export default component.exports